import Decimal from 'break_infinity.js'

const SUFFIXES = ['', 'K', 'M', 'B', 'T', 'Qa', 'Qi', 'Sx', 'Sp', 'Oc', 'No', 'Dc']

export const formatNumber = (n: Decimal): string => {
  if (n.lt(1000)) {
    return n.toFixed(2)
  }

  const exponent = Math.floor(n.e / 3)
  const suffixIndex = Math.min(exponent, SUFFIXES.length - 1)
  const mantissa = n.div(Decimal.pow(1000, suffixIndex))

  return `${mantissa.toFixed(2)}${SUFFIXES[suffixIndex]}`
}

export const formatTPS = (n: Decimal): string => {
  if (n.lt(1000)) {
    return n.toFixed(1)
  }

  const exponent = Math.floor(n.e / 3)
  const suffixIndex = Math.min(exponent, SUFFIXES.length - 1)
  const mantissa = n.div(Decimal.pow(1000, suffixIndex))

  return `${mantissa.toFixed(1)}${SUFFIXES[suffixIndex]}`
}
